import { AxiosResponse } from 'axios';
import { teamDelete, teamList, teamUpdate } from '@/api/team';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams, ITeamApiListResponse, ITeamDeleteResponse, ITeamUpdateResponse } from '@/types';

export const teamService = {
    async list(params: IListParams<Record<string, any>>): Promise<AxiosResponse<ITeamApiListResponse>> {
        try {
            return await baseListService<ITeamApiListResponse>(teamList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Team API Error:', e);
            throw new AppError(`Unable to load team list, request error`, { cause: e });
        }
    },

    async delete(id: number): Promise<AxiosResponse<ITeamDeleteResponse>> {
        try {
            return await teamDelete({ rows: [{ id }] });
        } catch (e) {
            console.error('Team delete API Error:', e);
            throw new AppError('Unable to delete team, request error', { cause: e });
        }
    },

    async updateAssociation(id: number, customTeamId: number | null): Promise<AxiosResponse<ITeamUpdateResponse>> {
        try {
            return await teamUpdate({ rows: [{ id, custom_team_id: customTeamId }] });
        } catch (e) {
            console.error('Team update API Error:', e);
            throw new AppError('Unable to update team association, request error', { cause: e });
        }
    },
};
